// Stage + priority + status visual system (matches design_guidelines.json)
export const STAGE_STYLES = {
  "New Lead": { bg: "#EFF6FF", text: "#1D4ED8", border: "#BFDBFE", dot: "#2563EB" },
  "Contacted": { bg: "#F0FDF4", text: "#15803D", border: "#BBF7D0", dot: "#16A34A" },
  "Qualified": { bg: "#FEFCE8", text: "#A16207", border: "#FEF08A", dot: "#CA8A04" },
  "Site Visit": { bg: "#FAF5FF", text: "#7E22CE", border: "#E9D5FF", dot: "#9333EA" },
  "Quotation": { bg: "#FFF7ED", text: "#C2410C", border: "#FFEDD5", dot: "#EA580C" },
  "Negotiation": { bg: "#FDF2F8", text: "#BE185D", border: "#FBCFE8", dot: "#DB2777" },
  "Won": { bg: "#ECFDF5", text: "#047857", border: "#A7F3D0", dot: "#059669" },
  "Lost": { bg: "#FEF2F2", text: "#B91C1C", border: "#FECACA", dot: "#DC2626" },
};

export const PRIORITY_STYLES = {
  "Low": { bg: "#F1F5F9", text: "#475569", dot: "#94A3B8" },
  "Medium": { bg: "#EFF6FF", text: "#1D4ED8", dot: "#3B82F6" },
  "High": { bg: "#FFF7ED", text: "#C2410C", dot: "#F97316" },
  "Urgent": { bg: "#FEF2F2", text: "#B91C1C", dot: "#EF4444" },
};

export const STATUS_STYLES = {
  "Pending": { bg: "#F1F5F9", text: "#475569" },
  "In Progress": { bg: "#EFF6FF", text: "#1D4ED8" },
  "Completed": { bg: "#ECFDF5", text: "#047857" },
  "Overdue": { bg: "#FEF2F2", text: "#B91C1C" },
};

export const CUSTOMER_STATUS_STYLES = {
  "Prospect": { bg: "#EFF6FF", text: "#1D4ED8" },
  "Customer": { bg: "#ECFDF5", text: "#047857" },
  "Repeat Customer": { bg: "#F5F3FF", text: "#6D28D9" },
  "Inactive": { bg: "#F1F5F9", text: "#64748B" },
};

export const PROJECT_STATUS_STYLES = {
  "Planning": { bg: "#EFF6FF", text: "#1D4ED8", dot: "#2563EB" },
  "In Progress": { bg: "#FFF7ED", text: "#C2410C", dot: "#EA580C" },
  "On Hold": { bg: "#FEFCE8", text: "#A16207", dot: "#CA8A04" },
  "Completed": { bg: "#ECFDF5", text: "#047857", dot: "#059669" },
  "Cancelled": { bg: "#FEF2F2", text: "#B91C1C", dot: "#DC2626" },
};

export const PHASE_STATUS_STYLES = {
  "Not Started": { bg: "#F1F5F9", text: "#475569", dot: "#94A3B8" },
  "In Progress": { bg: "#FFF7ED", text: "#C2410C", dot: "#EA580C" },
  "Completed": { bg: "#ECFDF5", text: "#047857", dot: "#059669" },
  "On Hold": { bg: "#FEFCE8", text: "#A16207", dot: "#CA8A04" },
  "Cancelled": { bg: "#FEF2F2", text: "#B91C1C", dot: "#DC2626" },
};

export const SITE_VISIT_STATUS_STYLES = {
  "Scheduled": { bg: "#EFF6FF", text: "#1D4ED8", dot: "#2563EB" },
  "Completed": { bg: "#ECFDF5", text: "#047857", dot: "#059669" },
  "Cancelled": { bg: "#FEF2F2", text: "#B91C1C", dot: "#DC2626" },
};

export const INVOICE_STATUS_STYLES = {
  "Draft": { bg: "#F1F5F9", text: "#475569", dot: "#94A3B8" },
  "Sent": { bg: "#EFF6FF", text: "#1D4ED8", dot: "#2563EB" },
  "Paid": { bg: "#ECFDF5", text: "#047857", dot: "#059669" },
};

export const CHART_COLORS = ["#0057A8", "#E31E24", "#0284C7", "#059669", "#D97706", "#7C3AED", "#DB2777", "#0891B2"];

export const ROLE_LABELS = {
  ADMIN: "Admin",
  SALES_MANAGER: "Sales Manager",
  SALES_EXECUTIVE: "Sales Executive",
  SITE_ENGINEER: "Site Engineer",
  ACCOUNTS: "Accounts",
};
